import React, { useContext } from 'react';

import Pips from '../Pips/Pips.js';
import * as styles from './Carousel.module.scss';
import { CarouselContext } from './CarouselProvider';

const ButtonPrev = ({ className, children }) => {
  const { state, dispatch } = useContext(CarouselContext);

  return (
    state.totalSlides > 1 && (
      <button
        type="button"
        className={className}
        aria-label="Previous item"
        onClick={(e) => dispatch({ type: 'PREV_SLIDE' })}
      >
        {children}
      </button>
    )
  );
};

const ButtonNext = ({ className, children }) => {
  const { state, dispatch } = useContext(CarouselContext);

  return (
    state.totalSlides > 1 && (
      <button
        type="button"
        className={className}
        aria-label="Next item"
        onClick={(e) => dispatch({ type: 'NEXT_SLIDE' })}
      >
        {children}
      </button>
    )
  );
};

const Counter = ({ className }) => {
  const { state } = useContext(CarouselContext);

  return (
    <span className={className} aria-hidden="true">
      {('0' + (state.currentIndex + 1)).slice(-2)} /{' '}
      {('0' + state.totalSlides).slice(-2)}
    </span>
  );
};

const Dots = (props) => {
  const { state, dispatch } = useContext(CarouselContext);

  return (
    <Pips
      {...props}
      count={state.totalSlides}
      currentIndex={state.currentIndex}
      onItemClick={(index) => dispatch({ type: 'GOTO_SLIDE', index })}
    />
  );
};

export { ButtonPrev, ButtonNext, Counter, Dots };
